import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { UserContext } from '../context/UserContext';
import { useTheme } from '../hooks/useTheme';
import Logo from './Logo';
import '../styles/main.css';

export default function Navbar({ businessName }) {
    const { cartItems, clearCart } = useContext(CartContext);
    const { user, setUser } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();

    const [salePointName, setSalePointName] = useState('');
    const [salePointArName, setSalePointArName] = useState('');
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { themeMode, setThemeModeDirectly } = useTheme();

   

    const menuRef = useRef(null);
    const dropdownRef = useRef(null);

    const count = cartItems.reduce((sum, i) => sum + i.quantity, 0);

    useEffect(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const extracted = pathSegments[1];

        if (extracted) {
            setSalePointName(extracted);

            fetch(`/api/salePointConfig/${businessName}/${extracted}`)
                .then((res) => {
                    if (!res.ok) throw new Error(`API error: ${res.status}`);
                    return res.json();
                })
                .then((config) => {
                    if (config.salePointArName) {
                        setSalePointArName(config.salePointArName);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching config:', error);
                });
        }
    }, [location.pathname, businessName]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        setUser(null);
        localStorage.setItem('isVerified', 'false');
        clearCart();
        setDropdownOpen(false);
        navigate(`/${businessName}/${salePointName}`);
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Left: Logo + Hamburger */}
                <div className="nav-left">
                    <Logo businessName={businessName} salePointName={salePointName} className="nav-logo" />

                    {/* Mobile Menu */}
                    <div className="hamburger-wrapper mobile-only" ref={menuRef}>
                        <button
                            className={`hamburger-button ${menuOpen ? 'open' : ''}`}
                            onClick={() => setMenuOpen(!menuOpen)}
                            aria-expanded={menuOpen}
                            aria-label="Menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>

                        {menuOpen && (
                            <div className="hamburger-dropdown">
                                <Link to={`/${businessName}/${salePointName}`} onClick={() => setMenuOpen(false)}>🏠 الرئيسية</Link>
                                <Link to={`/${businessName}/${salePointName}/about`} onClick={() => setMenuOpen(false)}>📄 من نحن</Link>
                                {user && (
                                    <>
                                        <Link to={`/${businessName}/${salePointName}/orders-history`} onClick={() => setMenuOpen(false)}>🧾 الطلبات السابقة</Link>
                                        <button onClick={handleLogout}>🚪 Logout</button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ✅ Desktop Menu */}
                    <div className="desktop-menu desktop-only">
                        <Link to={`/${businessName}/${salePointName}`}>🏠 الرئيسية</Link>
                        <Link to={`/${businessName}/${salePointName}/about`}>📄 من نحن</Link>

                    </div>
                </div>

                {/* Center: Sale Point Title */}
                <div className="nav-center">
                    <span className="nav-title shimmer-text">{salePointArName || salePointName}</span>
                </div>

                {/* Right: User Name + Dark Mode + Cart */}
                <div className="nav-right">
                    {user && (
                        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                            <div className="nav-phone">
                                <span className="phone-text">{user.name}</span>
                            </div>
                            <div className="dropdown-wrapper desktop-only" ref={dropdownRef}>
                                <button className="phone-button" onClick={() => setDropdownOpen(!dropdownOpen)}>
                                    👤 {user.phone}
                                </button>
                                {dropdownOpen && (
                                    <div className="dropdown-menu">
                                        <Link
                                            to={`/${businessName}/${salePointName}/orders-history`}
                                            onClick={() => setDropdownOpen(false)}
                                            className="dropdown-link"
                                        >
                                            🧾 الطلبات السابقة
                                        </Link>
                                        <button onClick={handleLogout}>🚪 تسجيل خروج</button>
                                    </div>
                                )}
                            </div>
                        </div>

                    )}
                    <div className="theme-buttons-group">
                        <button
                            className={`theme-btn ${themeMode === 'device' ? 'active' : ''}`}
                            onClick={() => setThemeModeDirectly('device')}
                            title="Device theme"
                        >
                            💻
                        </button>
                        <button
                            className={`theme-btn ${themeMode === 'dark' ? 'active' : ''}`}
                            onClick={() => setThemeModeDirectly('dark')}
                            title="Dark theme"
                        >
                            🌙
                        </button>
                        <button
                            className={`theme-btn ${themeMode === 'light' ? 'active' : ''}`}
                            onClick={() => setThemeModeDirectly('light')}
                            title="Light theme"
                        >
                            ☀️
                        </button>
                    </div>
                    <Link to={`/${businessName}/${salePointName}/cart`} className="nav-cart">
                        🛒 <strong className='cart-count'>({count})</strong>
                    </Link>
                </div>
            </div>
        </nav>
    );
}
